import { Sheet } from '../ui/Sheet';
import { ItemAvailabilityPanel } from './ItemAvailabilityPanel';
import { CrewAvailabilityPanel, type CrewCandidate } from './CrewAvailabilityPanel';

export type AvailabilityContext =
  | { kind: 'item'; itemId: string; name: string; locationId?: string }
  | {
      kind: 'crew';
      name: string;
      userId?: string;
      durationMinutes?: number;
      startsAt?: string;
      endsAt?: string;
    };

/** One accessible drawer shell; neither inspection path creates a hold or a booking. */
export function AvailabilitySheet({
  context,
  onClose,
  onApplyCrew,
}: {
  context: AvailabilityContext;
  onClose: () => void;
  onApplyCrew?: (candidate: CrewCandidate) => void;
}) {
  return (
    <Sheet
      wide
      open
      onClose={onClose}
      title={context.kind === 'item' ? context.name : 'Crew availability'}
    >
      {context.kind === 'item' ? (
        <ItemAvailabilityPanel
          itemId={context.itemId}
          initialLocationId={context.locationId}
        />
      ) : (
        <CrewAvailabilityPanel
          initialUserId={context.userId}
          initialDurationMinutes={context.durationMinutes}
          initialStartAt={context.startsAt}
          initialEndAt={context.endsAt}
          onApply={onApplyCrew}
        />
      )}
    </Sheet>
  );
}
